// src/components/ReactFlow/ConnectBranches.tsx

interface ConnectBranchesFormProps {
   optionPairId: number;
   onClose: () => void;
   onConnected: () => void;
}

export function ConnectBranchesForm({
   optionPairId,
   onClose,
   onConnected,
}: ConnectBranchesFormProps) {
   return (
      <div
         style={{
            position: "absolute",
            top: 50,
            left: 50,
            padding: "1rem",
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: "6px",
            zIndex: 2000,
         }}
      >
         <h3>Connect Branches for Option Pair {optionPairId}</h3>
         {/* Your form fields or logic here */}
         <button
            onClick={() => {
               // Some connect logic
               onConnected();
               onClose();
            }}
         >
            Connect
         </button>
         <button onClick={onClose}>Cancel</button>
      </div>
   );
}
